import { render, staticRenderFns } from "./import-file.vue?vue&type=template&id=16413f88&scoped=true&"
import script from "./import-file.vue?vue&type=script&lang=js&"
export * from "./import-file.vue?vue&type=script&lang=js&"
import style0 from "./import-file.vue?vue&type=style&index=0&id=16413f88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16413f88",
  null
  
)

export default component.exports